// Google Ads & GTM Conversion Tracking Utilities

export const PHONE_NUMBER = '+40726375166';
export const PHONE_NUMBER_DISPLAY = '+40 726 375 166';

// Track phone call click conversion
export const trackPhoneClick = () => {
  // Google Ads Conversion Tracking
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18006103810/Xj4vCMbdhYYcEIKu_YlD',
      'event_category': 'engagement',
      'event_label': 'phone_click'
    });
    console.log('Phone click conversion tracked');
  }
  
  // GTM DataLayer push for additional tracking
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      'event': 'phone_click',
      'phone_number': PHONE_NUMBER
    });
  }
};

// Track booking form submission
export const trackBookingSubmission = (value, currency = 'EUR') => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18006103810/Xj4vCMbdhYYcEIKu_YlD',
      'value': value,
      'currency': currency,
      'transaction_id': Date.now().toString()
    });
    console.log('Booking conversion tracked');
  }
  
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      'event': 'booking_submission',
      'booking_value': value,
      'currency': currency
    });
  }
};

// Track WhatsApp click
export const trackWhatsAppClick = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18006103810',
      'event_category': 'engagement',
      'event_label': 'whatsapp_click'
    });
  }
  
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      'event': 'whatsapp_click'
    });
  }
};
